import { useContext } from 'react';

import { Viewer, ViewerContext } from './ViewerContext';

/**
 * Shortcut utility to get type-asserted viewer in current context.
 *
 * @returns currently supplied viewer object from React context
 */
export function useViewer(): Viewer {
  return useContext(ViewerContext) as Viewer;
}
